module.exports = __webpack_public_path__ + "img/partner_6.f512cbb0.png";